var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "price-summary",
    class: [{
      'price-summary_loading': _vm.loading
    }]
  }, [_c('div', {
    staticClass: "price-summary__prop-list dark-yellow-text p"
  }, [_c('div', {
    staticClass: "price-summary__monthly-payment"
  }, [_c('div', {
    staticClass: "price-summary__prop-monthly"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "price-summary__prop-total b"
  }, [_vm._v("\n        " + _vm._s(_vm.total) + " "), _c('span', {
    staticClass: "price-summary__ruble"
  }, [_vm._v("₽")])])]), _vm._v(" "), _vm.total !== '-' ? _c('div', {
    staticClass: "price-summary__prop"
  }, _vm._l(_vm.list, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "price-summary__prop-item"
    }, [_c('p', {
      staticClass: "price-summary__prop-text"
    }, [_vm._v("\n          " + _vm._s(item.text) + "\n        ")]), _vm._v(" "), item.value ? _c('p', {
      staticClass: "price-summary__props-list-value"
    }, [_vm._v("\n          " + _vm._s(item.value) + "\n          "), _c('span', {
      staticClass: "price-summary__ruble price-summary__ruble_small"
    }, [_vm._v("₽")])]) : _vm._e()]);
  }), 0) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }